import React from 'react';
import { Award, Star, Trophy, Zap } from 'lucide-react';

const PressRecognitionSection = () => {
  const pressItems = [
    {
      outlet: "Forbes",
      headline: "Leading the Conscious Business Revolution",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/0/0c/Forbes_logo.svg/200px-Forbes_logo.svg.png"
    },
    {
      outlet: "Business Insider",
      headline: "The Future of B2B Certification",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/1/12/Business_Insider_Logo.svg/200px-Business_Insider_Logo.svg.png"
    },
    {
      outlet: "TechCrunch",
      headline: "Revolutionizing Corporate Sustainability",
      logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/b/b9/TechCrunch_logo.svg/200px-TechCrunch_logo.svg.png"
    }
  ];

  const recognitions = [
    {
      icon: Award,
      title: "Best Impact Platform 2024",
      org: "Global Sustainability Awards"
    },
    {
      icon: Trophy,
      title: "Innovation in B2B Certification",
      org: "Business Excellence Forum"
    },
    {
      icon: Star,
      title: "Top 10 Conscious Business Platforms",
      org: "Conscious Capitalism Network"
    },
    {
      icon: Zap,
      title: "Emerging Leader in ESG",
      org: "Environmental Business Journal"
    }
  ];

  return (
    <div className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center px-4 py-2 mb-4 bg-blue-50 text-blue-700 rounded-full text-sm font-medium">
            🏆 Recognition & Media
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-4">
            As Seen <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">On</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Recognized by leading media outlets and industry organizations for pioneering conscious business certification
          </p>
        </div>

        {/* Press Coverage */}
        <div className="mb-16">
          <h3 className="text-xl font-bold text-gray-900 mb-8 text-center">Featured In</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {pressItems.map((item, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all border border-gray-100 text-center">
                <div className="h-16 flex items-center justify-center mb-4">
                  <div className="text-2xl font-black text-gray-900">{item.outlet}</div>
                </div>
                <p className="text-sm text-gray-600 font-medium">
                  "{item.headline}"
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Awards & Recognition */}
        <div>
          <h3 className="text-xl font-bold text-gray-900 mb-8 text-center">Awards & Recognition</h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {recognitions.map((item, index) => {
              const Icon = item.icon;
              return (
                <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all border border-gray-100 text-center">
                  <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-full flex items-center justify-center mx-auto mb-4">
                    <Icon className="h-6 w-6 text-white" />
                  </div>
                  <h4 className="font-bold text-gray-900 mb-2 text-sm">{item.title}</h4>
                  <p className="text-xs text-gray-600">{item.org}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-16 text-center">
          <p className="text-gray-600 mb-6">
            Join the movement recognized by industry leaders worldwide
          </p>
          <a href="/certification">
            <button className="px-8 py-4 bg-gradient-to-r from-blue-600 to-indigo-600 text-white font-bold rounded-full hover:from-blue-700 hover:to-indigo-700 transition-all shadow-lg hover:shadow-xl">
              Start Your Certification Journey
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default PressRecognitionSection;
